// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faFilePdf } from "@fortawesome/free-solid-svg-icons";

// export default function TaskReportDetail({ report, onClose }) {
//   if (!report) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//       <div className="bg-white w-full max-w-3xl rounded-xl shadow-xl animate-fadeIn p-6 max-h-[90vh] overflow-y-auto relative">

//         {/* Nút đóng */}
//         <button
//           className="absolute top-3 right-3 text-gray-600 hover:text-red-600"
//           onClick={onClose}
//         >
//           <FontAwesomeIcon icon={faTimes} size="lg" />
//         </button>

//         {/* Title */}
//         <h2 className="text-xl font-semibold mb-4 text-gray-800">
//           📄 Chi tiết báo cáo công việc
//         </h2>

//         {/* Thông tin nhân viên */}
//         <div className="grid grid-cols-2 gap-4 mb-4">
//           <div>
//             <p className="text-sm text-gray-500">Nhân viên</p>
//             <p className="font-medium">{report.employee_name}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500">Chi nhánh</p>
//             <p className="font-medium">{report.branch_name}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500">Bộ phận</p>
//             <p className="font-medium">{report.department_name}</p>
//           </div>
//           <div>
//             <p className="text-sm text-gray-500">Ngày tạo</p>
//             <p className="font-medium">{report.created_at}</p>
//           </div>
//         </div>

//         {/* Thời gian */}
//         <div className="bg-gray-50 rounded-lg p-4 mb-4">
//           <p className="text-sm text-gray-500">Khoảng thời gian</p>
//           <p className="font-medium">
//             {report.from_date} → {report.to_date}
//           </p>
//         </div>

//         {/* Nội dung tóm tắt */}
//         <div className="mb-4">
//           <p className="text-sm text-gray-500">Nội dung tổng kết</p>
//           <p className="font-medium whitespace-pre-wrap">
//             {report.report_summary || "—"}
//           </p>
//         </div>

//         {/* Danh sách công việc */}
//         <div className="mt-6">
//           <h3 className="font-semibold text-gray-700 mb-2">
//             Danh sách công việc ({report.tasks?.length || 0})
//           </h3>

//           <div className="border rounded-lg">
//             {report.tasks?.map((t, i) => (
//               <div
//                 key={i}
//                 className="border-b p-3 hover:bg-gray-50 text-sm"
//               >
//                 <p className="font-medium">{t.taskname}</p>
//                 <p className="text-gray-500">{t.work_day}</p>
//                 <p className="text-gray-600 text-sm whitespace-pre-wrap mt-1">
//                   {t.note}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* PDF */}
//         {report.pdf_url && (
//           <div className="mt-6 text-center">
//             <a
//               href={report.pdf_url}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition"
//             >
//               <FontAwesomeIcon icon={faFilePdf} />
//               Tải PDF
//             </a>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }









import React from "react";
import { 
  X, User, Building2, MapPin, Calendar, 
  FileText, Briefcase, Star, FileDown, Clock, ClipboardList, Paperclip, Trash2
} from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { formatDateVN } from "../../../utils/formatUtils";
import dayjs from "dayjs";

const TaskReportDetail = ({ report, onClose, currentUserId, onDelete, deleting = false }) => {
  if (!report) return null;
  const formatTaskDay = (value) => {
    if (!value) return "—";
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format("DD-MMM-YYYY") : value;
  };
  const attachmentUrl =
    report?.attachment_url ||
    report?.attachment_file_url ||
    report?.report_attachment_url ||
    report?.attached_pdf_url ||
    "";
  const attachmentName =
    report?.attachment_name ||
    report?.attachment_file_name ||
    report?.attached_pdf_name ||
    "File đính kèm";
  const canDelete = Boolean(currentUserId && report?.created_by && currentUserId === report.created_by);

  // Helper hiển thị từng dòng thông tin
  const infoItem = (Icon, label, value, iconColor = "text-gray-400") => (
    <div className="flex items-center gap-4 p-3 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100">
      <div className={`p-2 rounded-lg bg-gray-50 ${iconColor}`}>
        <Icon size={18} />
      </div>
      <div>
        <p className="text-[10px] font-bold text-gray-400 uppercase tracking-tight">{label}</p>
        <p className="text-sm font-semibold text-gray-700">{value || "—"}</p>
      </div>
    </div>
  );

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm z-[100] flex items-center justify-center p-4"
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.95, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 20 }}
          onClick={(e) => e.stopPropagation()}
          className="bg-white w-full max-w-3xl rounded-3xl shadow-2xl overflow-hidden flex flex-col max-h-[90vh]"
        >
          {/* Header: Profile Style */}
          <div className="relative p-6 border-b border-gray-100 flex items-center justify-between bg-white">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-red-50 text-red-600 flex items-center justify-center text-2xl font-black border border-red-100 shadow-sm">
                {report.employee_name?.charAt(0).toUpperCase()}
              </div>
              <div>
                <h2 className="text-xl font-bold text-gray-800">{report.employee_name}</h2>
                <div className="flex items-center gap-2 mt-1">
                  <span className="px-2 py-0.5 bg-gray-100 text-gray-500 rounded text-[10px] font-bold uppercase">
                    {report.department_name}
                  </span>
                  <span className="px-2 py-0.5 bg-red-50 border border-red-100 text-red-600 rounded text-[10px] font-bold uppercase">
                    {report.branch_name}
                  </span>
                </div>
              </div>
            </div>
            
            <button 
              onClick={onClose}
              className="p-2 hover:bg-gray-100 text-gray-400 hover:text-gray-600 rounded-full transition-all"
            >
              <X size={24} />
            </button>
          </div>

          {/* Body Content */}
          <div className="flex-1 overflow-y-auto p-8 custom-scrollbar bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              
              {/* Cột trái: Thông tin chung */}
              <div className="space-y-6">
                <div>
                  <h3 className="text-[11px] font-black text-red-600 uppercase tracking-widest mb-4 flex items-center gap-2">
                    <div className="w-1 h-4 bg-red-600 rounded-full" /> Thông tin chung
                  </h3>
                  <div className="space-y-1">
                    {infoItem(Calendar, "Khoảng thời gian", `${formatDateVN(report.from_date)} - ${formatDateVN(report.to_date)}`, "text-indigo-500")}
                    {infoItem(Clock, "Ngày tạo báo cáo", report.created_at, "text-gray-500")}
                    {infoItem(Star, "Điểm trung bình", report.avg_completed_point ? `${Number(report.avg_completed_point).toFixed(2)} / 10` : "Chưa chấm", "text-yellow-500")}
                  </div>
                </div>

                <div>
                  <h3 className="text-[11px] font-black text-red-600 uppercase tracking-widest mb-4 flex items-center gap-2">
                    <div className="w-1 h-4 bg-red-600 rounded-full" /> Tóm tắt nội dung
                  </h3>
                  <div className="p-4 rounded-2xl bg-gray-50 border border-gray-100 text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {report.report_summary || "Không có nội dung tóm tắt."}
                  </div>
                </div>

                <div>
                  <h3 className="text-[11px] font-black text-red-600 uppercase tracking-widest mb-4 flex items-center gap-2">
                    <div className="w-1 h-4 bg-red-600 rounded-full" /> File báo cáo
                  </h3>
                  <div className="space-y-2">
                    {report.pdf_url ? (
                      <a
                        href={report.pdf_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-red-200 hover:bg-red-50/40 transition-all"
                      >
                        <FileDown size={16} className="text-red-600" />
                        <div>
                          <p className="text-xs font-bold text-gray-700">Báo cáo tổng hợp từ app</p>
                          <p className="text-[11px] text-gray-500">PDF hệ thống sinh tự động</p>
                        </div>
                      </a>
                    ) : (
                      <div className="p-3 rounded-xl border border-gray-100 text-xs text-gray-400">
                        Không có file PDF tổng hợp.
                      </div>
                    )}

                    {attachmentUrl ? (
                      <a
                        href={attachmentUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-3 p-3 rounded-xl border border-gray-100 hover:border-blue-200 hover:bg-blue-50/40 transition-all"
                      >
                        <Paperclip size={16} className="text-blue-600" />
                        <div className="min-w-0">
                          <p className="text-xs font-bold text-gray-700">Báo cáo đính kèm</p>
                          <p className="text-[11px] text-gray-500 truncate">{attachmentName}</p>
                        </div>
                      </a>
                    ) : (
                      <div className="p-3 rounded-xl border border-gray-100 text-xs text-gray-400">
                        Không có file đính kèm.
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Cột phải: Danh sách công việc */}
              <div className="space-y-6">
                <h3 className="text-[11px] font-black text-red-600 uppercase tracking-widest mb-4 flex items-center gap-2">
                  <div className="w-1 h-4 bg-red-600 rounded-full" /> Chi tiết công việc ({report.tasks?.length || 0})
                </h3>
                <div className="space-y-3 max-h-[400px] overflow-y-auto pr-2 custom-scrollbar">
                  {report.tasks?.map((t, i) => (
                    <div key={i} className="p-4 rounded-2xl border border-gray-100 hover:border-red-100 hover:bg-red-50/30 transition-all group">
                      <div className="flex justify-between items-start mb-2">
                        <p className="font-bold text-gray-800 text-sm group-hover:text-red-700 transition-colors">
                          {t.taskname}
                        </p>
                        <span className="text-[10px] font-medium text-gray-400 bg-white px-2 py-0.5 rounded border border-gray-100">
                          {formatTaskDay(t.work_day)}
                        </span>
                      </div>
                      <p className="text-xs text-gray-500 leading-normal whitespace-pre-wrap">
                        {t.note}
                      </p>
                    </div>
                  ))}
                  {(!report.tasks || report.tasks.length === 0) && (
                    <div className="text-center py-8 text-gray-400 italic text-sm">
                      Không có danh sách công việc đính kèm
                    </div>
                  )}
                </div>
              </div>

            </div>
          </div>

          {/* Footer Action */}
          <div className="p-6 border-t border-gray-50 bg-gray-50/30 flex justify-end gap-3">
            {canDelete && (
              <button
                type="button"
                onClick={() => onDelete?.(report)}
                disabled={deleting}
                className="px-6 py-3 bg-rose-600 hover:bg-rose-700 text-white font-bold rounded-xl flex items-center gap-2 shadow-lg shadow-rose-100 transition-all active:scale-95 disabled:opacity-50"
              >
                <Trash2 size={18} /> {deleting ? "ĐANG XÓA..." : "XÓA BÁO CÁO"}
              </button>
            )}
            <button 
              onClick={onClose}
              className="px-6 py-3 rounded-xl font-bold text-gray-500 hover:bg-gray-100 transition-all"
            >
              ĐÓNG
            </button>
            {report.pdf_url && (
              <a 
                href={report.pdf_url}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white font-bold rounded-xl flex items-center gap-2 shadow-lg shadow-red-100 transition-all active:scale-95"
              >
                <FileDown size={18} /> XUẤT PDF
              </a>
            )}
            {attachmentUrl && (
              <a
                href={attachmentUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl flex items-center gap-2 shadow-lg shadow-blue-100 transition-all active:scale-95"
              >
                <Paperclip size={18} /> FILE ĐÍNH KÈM
              </a>
            )}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TaskReportDetail;